import { useEffect, useState } from "react";
import CategorySection from "../components/Category";
import FullLibrarySection from "../components/Home/FullLibrary";
import Hero from "../components/Home/HeroSection";
import MarqueeStrip from "../components/Home/MarqueeStrip";
import NewArrivalsSection from "../components/Home/NewArrival";
import NewsletterSection from "../components/NewsLetter";
import TopRatedSection from "../components/TopRatedSection";
import EditorsPickSection from "../components/Home/EditorsPickSection";
import TrendingSection from "../components/TrendingSection";
import AuthorSection from "../components/AuthorSection";
import { fetchHomepageSections, fetchBanners, fetchAuthors } from "../api";
import { buildManualSectionBooks, HOME_PAGE_SECTION_DEFAULTS, normalizeHomepageSections } from "../homepageSections";

// Fallback banners used when no banners are configured in the admin panel
const FALLBACK_BANNERS = [
	{ id: 'promo-1', image: "/banner/1.jpeg", href: "/store" },
	{ id: 'promo-2', image: "/banner/2.jpeg", href: "/store" },
	{ id: 'promo-3', image: "/banner/3.jpeg", href: "/store" },
	{ id: 'promo-4', image: "/banner/4.jpeg", href: "/store" },
	{ id: 'promo-5', image: "/banner/5.jpeg", href: "/store" },
	{ id: 'promo-6', image: "/banner/6.jpeg", href: "/store" },
	{ id: 'promo-7', image: "/banner/7.jpeg", href: "/store" },
];

export default function HomePage({ books, onView, cart, addCart }) {
	const [sectionConfigs, setSectionConfigs] = useState(HOME_PAGE_SECTION_DEFAULTS);
	const [homeBanners, setHomeBanners] = useState(FALLBACK_BANNERS);
	const [authors, setAuthors] = useState([]);

	useEffect(() => {
		let isMounted = true;

		const loadHomepageSections = async () => {
			try {
				const data = await fetchHomepageSections();
				if (isMounted) {
					setSectionConfigs(normalizeHomepageSections(data.sections));
				}
			} catch (error) {
				console.error("Failed to load homepage section config:", error);
			}
		};

		const loadBanners = async () => {
			try {
				const data = await fetchBanners();
				if (isMounted && Array.isArray(data) && data.length > 0) {
					setHomeBanners(data.map((b) => ({
						id: `banner-${b.id}`,
						image: b.image_url,
						href: b.href || "/store",
					})));
				}
			} catch (error) {
				console.error("Failed to load banners, using fallbacks:", error);
			}
		};

		const loadAuthors = async () => {
			try {
				const data = await fetchAuthors();
				if (isMounted && Array.isArray(data)) {
					setAuthors(data);
				}
			} catch (error) {
				console.error("Failed to load authors:", error);
			}
		};

		loadHomepageSections();
		loadBanners();
		loadAuthors();

		return () => {
			isMounted = false;
		};
	}, []);

	const trendingConfig = sectionConfigs.trending || HOME_PAGE_SECTION_DEFAULTS.trending;
	const categoryConfig = sectionConfigs.category || HOME_PAGE_SECTION_DEFAULTS.category;
	const topRatedConfig = sectionConfigs.topRated || HOME_PAGE_SECTION_DEFAULTS.topRated;
	const editorsPickConfig = sectionConfigs.editorsPick || HOME_PAGE_SECTION_DEFAULTS.editorsPick;
	const authorsConfig = sectionConfigs.authors || HOME_PAGE_SECTION_DEFAULTS.authors;

	return (
		<div>
			<Hero banners={homeBanners} />
			<MarqueeStrip />
			{/* <StatsTicker /> */}
			<NewArrivalsSection books={books} onView={onView} cart={cart} addCart={addCart} />
			{trendingConfig.isActive && (
				<TrendingSection
					books={books}
					selectedBooks={buildManualSectionBooks(books, trendingConfig)}
					itemLimit={trendingConfig.itemLimit}
					onView={onView}
					cart={cart}
					addCart={addCart}
				/>
			)}
			{/* <FlashDealsSection books={books} onView={onView} cart={cart} addCart={addCart} /> */}
			{categoryConfig.isActive && (
				<CategorySection
					books={books}
					selectedBooks={buildManualSectionBooks(books, categoryConfig)}
					itemLimit={categoryConfig.itemLimit}
					onView={onView}
					cart={cart}
					addCart={addCart}
				/>
			)}
			{authorsConfig.isActive && (
				<AuthorSection authors={authors} />
			)}
			{topRatedConfig.isActive && (
				<TopRatedSection
					books={books}
					selectedBooks={buildManualSectionBooks(books, topRatedConfig)}
					itemLimit={topRatedConfig.itemLimit}
					onView={onView}
					cart={cart}
					addCart={addCart}
				/>
			)}
			{editorsPickConfig.isActive && (
				<EditorsPickSection
					books={books}
					selectedBooks={buildManualSectionBooks(books, editorsPickConfig)}
					itemLimit={editorsPickConfig.itemLimit}
					onView={onView}
					cart={cart}
					addCart={addCart}
				/>
			)}
			<FullLibrarySection books={books} onView={onView} cart={cart} addCart={addCart} />
			<NewsletterSection />
		</div>
	);
}
